function GlobalFooter(){
    return(
        <div className="flex flex-col sm:flex-row justify-between items-center text-sm text-gray-600">
            <div className="flex items-center space-x-4 mb-2 sm:mb-0">
                <p className="font-medium">
                    © 2025 GesLocative - Gestion Immobilière
                </p>
                <span className="hidden sm:inline-block w-1 h-1 bg-gray-400 rounded-full"></span>
                <span className="text-xs">Version 1.0.0</span>
            </div>
            
            <div className="flex items-center space-x-4">
                <a href="#" className="hover:text-blue-600 transition-colors">
                    Aide
                </a>
                <span className="w-1 h-1 bg-gray-400 rounded-full"></span>
                <a href="#" className="hover:text-blue-600 transition-colors">
                    Support
                </a>
                <span className="w-1 h-1 bg-gray-400 rounded-full"></span>
                <span className="text-xs text-gray-500">
                    Dernière mise à jour: {new Date().toLocaleDateString('fr-FR')}
                </span>
            </div>
        </div>
    )
}
export default GlobalFooter;